import { useDispatch } from "react-redux";
import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components";
import { CssBaseline } from "@mui/material";
import PerfectScrollBar from "react-perfect-scrollbar";

import GlobalStyle from "../components/GlobalStyle";
import Banner from "../assets/auth carousel pics/sigin.png";
import { renderUserInterface } from "../redux/slices/renderUISlice";

const ImageDiv = styled.div`
  flex: 2 1 0%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-right: 0.5px solid #cbcbcb57;
`;

// Root wrapper
const Root = styled.div`
  display: flex;
  height: 100vh;
  width: 100vw;
`;

// Scrollable right side
const ScrollBar = styled(PerfectScrollBar)`
  height: 100%;
  overflow: hidden;
  width: 40%;

  @media (max-width: 1100px) {
    width: 100%;
  }

  @media (max-width: 850px) {
    width: 100%;
  }
`;

// Right panel content container
const MainDiv = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  & > * {
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media (max-width: 850px) {
    padding: 20px;
    margin: 0;
  }

  @media (max-width: 1100px) {
    padding: 20px;
    margin: 0;
  }
`;

export default function AuthLayout() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(renderUserInterface());
  }, [dispatch]);

  return (
    <Root>
      <CssBaseline />
      <GlobalStyle />

      <ImageDiv id="gif">
        <img
          style={{ width: "80%", height: "80%" }}
          alt="banner"
          src={Banner}
        />
      </ImageDiv>

      <ScrollBar>
        <MainDiv>
          <Outlet />
        </MainDiv>
      </ScrollBar>
    </Root>
  );
}
